const extensionsMap: { [key: string]: string } = {
  ai: 'ai.svg',
  docx: 'docx.svg',
  m4v: 'm4v.svg',
  otf: 'otf.svg',
  psd: 'psd.svg',
  txt: 'txt.svg',
  avi: 'avi.svg',
  eps: 'eps.svg',
  mkv: 'mkv.svg',
  pdf: 'pdf.svg',
  rar: 'rar.svg',
  wav: 'wav.svg',
  css: 'css.svg',
  exe: 'exe.svg',
  mov: 'mov.svg',
  php: 'php.svg',
  svg: 'svg.svg',
  xls: 'xls.svg',
  csv: 'csv.svg',
  html: 'html.svg',
  mp4: 'mp4.svg',
  png: 'png.svg',
  tif: 'tif.svg',
  xlsm: 'xlsm.svg',
  default: 'default.svg',
  jpeg: 'jpeg.svg',
  mpeg: 'mpeg.svg',
  ppt: 'ppt.svg',
  tiff: 'tiff.svg',
  xlsx: 'xlsx.svg',
  doc: 'doc.svg',
  jpg: 'jpg.svg',
  mpg: 'mpg.svg',
  pptx: 'pptx.svg',
  ttf: 'ttf.svg',
  zip: 'zip.svg',
}

const getIconPath = (file: File | string) => {
  const isUrl = typeof file === 'string'

  if (!file) return `/icons/${extensionsMap.default}`
  if (isUrl) {
    if (file.includes('.') && file.includes('?')) {
      const extension = file.split('.').pop()?.split('?')[0] ?? ''
      return `/icons/${extensionsMap[extension] || extensionsMap.default}`
    }
    return `/icons/${extensionsMap.default}`
  } else {
    const extension = file.type.split('/').pop() ?? ''
    const iconPath = extensionsMap[extension] || extensionsMap.default
    return `/icons/${iconPath}`
  }
}

export default getIconPath
